<template>
  <div>
    <a-button type="primary" @click="showModal">
      Créer un incident
    </a-button>
    <a-modal v-model="visible" title="Renseignements" @ok="handleOk">
      <a-form :form="form">
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="Contact"
        >
          <a-input
            ref="contact"
            v-decorator="[
              'contact',
              {
                rules: [
                  {
                    required: true,
                    message: 'Merci de renseigner un nom valide',
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="Tel"
        >
          <a-input
            ref="tel"
            v-decorator="[
              'tel',
              {
                rules: [
                  {
                    pattern: new RegExp(
                      /^(?:(?:\+|00)33[\s.-]{0,3}(?:\(0\)[\s.-]{0,3})?|0)[1-9](?:(?:[\s.-]?\d{2}){4}|\d{2}(?:[\s.-]?\d{3}){2})$/
                    ),
                    message:
                      'Merci de renseigner un numéro de télephone valide',
                  },
                ],
              },
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
const formItemLayout = {
  labelCol: { span: 9 },
  wrapperCol: { span: 10 },
};
const formTailLayout = {
  labelCol: { span: 9 },
  wrapperCol: { span: 10, offset: 4 },
};

export default {
  components: {},

  data() {
    return {
      visible: false,

      formItemLayout,
      formTailLayout,
      form: this.$form.createForm(this, { name: "dynamic_rule" }),
    };
  },
  methods: {
    showModal() {
      this.visible = true;
    },

    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.sendData(values);
          this.visible = false;
        }
      });
    },
    sendData(values) {
      const userInformation = {
        contact: values.contact,
        tel: values.tel,
      };
      this.$emit("onUserInformation", userInformation);
    },
  },
};
</script>
